export const LeftAngleIcon = () => (
	<svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M5.18359 10.3673L0.816292 6.00001L5.18359 1.63271"
			stroke="#140F33"
			strokeWidth="1.5"
			strokeLinecap="square"
			strokeLinejoin="round"
		/>
	</svg>
);
